import React, { useState, useEffect } from 'react';
import Button from '../../../Buttons/ButtonBase';
import { connect } from 'react-redux';
import moment from 'moment';
import { updateLike } from '../../../../store/actions/CommunityAction';
import MakeYourQuestion from './MakeYourQuestion';
import "./CardAnswerQuestion.scss";

const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const CardAnswerQuestion  = ({
    body,
    index,
    updateLike,
    clientUid,
    roleUser,
    answers,
    responseArray,
    isLawyer,
    handleLoginModal,
}) => {
    const { question } = answers.data
    const {
        id,
        likes,
        response,
        lawyerUsers,
    } = body
    const {
        uid,
        role,
        name,
        genero,
        createAt,
        gotLikes,
        officeName,
        membership,
        imgProfile,
        responseTime,
        firstLastName,
        secondLastName,
        totalResponsesMade,
    } = lawyerUsers

    const defaultAvatar =
    role && role === 'lawyer' ? (
        genero === 'male' ?
        maleAvatar :
        femaleAvatar
    ) :
    lawFirmAvatar;

    let levelImg = ''
    if (responseTime && responseTime === 'fast') {
        levelImg = '/img/responseTime/fast-response.svg'
    } else if (responseTime && responseTime === 'mid') {
        levelImg = '/img/responseTime/normal-response.svg'
    } else if (responseTime && responseTime === 'low') {
        levelImg = '/img/responseTime/slow-response.svg'
    }

    const creationDate = moment.unix(createAt._seconds).format('DD MMMM YYYY')

    const [ like, setLike ] = useState(false)
    const [ dislike, setDislike ] = useState(false)

    const seeAnswerLikes = () => {
        let likesTotal = []
        if (Array.isArray(likes)) {
            likesTotal = likes.filter(elem => {
                return elem.util === 'like'
            })
        }
        return likesTotal.length
    }

    useEffect(() => {
        if (likes && likes.length !== 0) {
            const likeIndex = likes.findIndex(elem => elem.clientUid === clientUid)
            if (likes && likes[likeIndex] && likes[likeIndex].util === 'like') {
                setLike(true)
                setDislike(false)
            } else if (likes && likes[likeIndex] && likes[likeIndex].util === 'dislike') {
                setLike(false)
                setDislike(true)
            } else {
                setLike(false)
                setDislike(false)
            }
        }
    }, [clientUid, likes])

    const changeLike = (item) => {
        let likeStatus
        switch(item) {
            case 'like':
                likeStatus = 'like';
                setLike(true)
                setDislike(false)
                break
            case 'dislike':
                likeStatus = 'dislike';
                setLike(false)
                setDislike(true)
                break
            default:
                likeStatus = '';
                setLike(false)
                setDislike(false)
                break
        }

        if (roleUser === 'cliente') {
            updateLike(
                clientUid,
                uid,
                likeStatus,
                question.id,
                id,
                likes,
                responseArray,
                item,
                like,
                gotLikes,
            )
        }
    }

    const calculateIsNotMultiple = () => {
        const value = (index + 1) % 3
        let isNotMultiple = Boolean(value)
        if (index === 0) {
            isNotMultiple = true
        }
        return isNotMultiple
    }

    return (
        <>
            <div className={'answerQuestion'}>  
                <div className='cardAnwer'>
                    <div className="marked">
                        Marcada como útil por <span className="markedNumber">{seeAnswerLikes()}</span> {seeAnswerLikes() === 1 ? 'persona' : 'personas'}
                    </div>
                    <div className='answerText'>
                        <p>
                            {response && response}
                        </p>
                    </div>
                    {!isLawyer ?
                        <div className='answerContainer'>
                            <div><p className='answerBold'>¿Te resultó útil la respuesta?</p></div>
                            <div
                                onClick={
                                    !roleUser ?
                                    handleLoginModal :
                                    !like ?
                                    () => changeLike('like') :
                                    () => changeLike('')
                                }
                                className='likeContainer'
                            >     
                                <img  src={like && like ? ('/img/icons/icons-acento-like.svg') : ('/img/icons/icon-like.svg') }  alt=''/>
                                <span className='textGray'>Sí</span>

                            </div>
                            <div
                                onClick={
                                    !roleUser ?
                                    handleLoginModal :
                                    !dislike ?
                                    () => changeLike('dislike') :
                                    () => changeLike('')
                                }
                                className='likeContainer leftSpace24'
                            >
                                <img  src={dislike && dislike ? ('/img/icons/icons-acento-dislike.svg') : ('/img/icons/dislike.svg') }   alt=''/> 
                                <span className='textGray'>No</span>
                            </div>
                        </div> : null
                    }
                    <hr className='grayLine'/> 
                </div>
                <div className='cardAnwerInfo'>
                    <div className='topContainer'>
                        <div className='imgContent'>
                            <img src={imgProfile ? imgProfile : defaultAvatar} alt=''/>
                        </div>
                        <div className='rightTopContainer'>
                            <p className='titleLawyer marginTop5'>
                                {role === 'lawyer' ?
                                    `${name} ${firstLastName} ${secondLastName}` :
                                    `${officeName}`
                                }
                            </p>
                            <div className='timeType'>
                                <p className='fechaLawyer'>{creationDate}</p>
                            </div>
                        </div>
                    </div>
                <div className='centerItems'>
                    <div className='itemsTop'>
                    <div className='centerContainer'>
                            <div className='iconContainer'>
                                <img className='img' src='/img/icons/respuestas.svg'  alt=''/>
                            </div>
                            <div className='textContainer'>
                                <p className='titleLawyer marginBottom7'>Respuestas brindadas</p>
                                <p>
                                    {totalResponsesMade &&
                                    totalResponsesMade === 1 ?
                                        '1 respuesta' :
                                    totalResponsesMade ?
                                        `${totalResponsesMade} respuestas` :
                                        ''
                                    }
                                </p>
                            </div>
                    </div>
                    <hr className='veticalLine'/>
                    <div className='centerContainer'>
                            <div className='iconContainer'>
                                <img className='img' src='/img/icons/like.svg'  alt=''/>
                            </div>
                            <div className='textContainer'>
                                <p className='titleLawyer marginBottom7'>Votos positivos</p>
                                <p>
                                    {gotLikes && gotLikes === 1 ?
                                    '1 voto' :
                                    gotLikes ?
                                    `${gotLikes} votos` : '0 votos'
                                    }
                                </p>
                            </div>
                    </div>
                    </div>
                    <div className='centerContainer'>
                        <div className='iconContainer'>
                            {levelImg ?
                                <img className='img' src={levelImg} alt=''/> :
                                null
                            }
                        </div>
                        <div className='textTimeContainer'>
                            {responseTime === 'fast' ?
                            <p className='titleTimeLawyer_fast'>
                                Nivel de respuesta alto
                            </p> :
                            responseTime === 'mid' ?
                            <p className='titleTimeLawyer_mid'>
                                Nivel de respuesta medio
                            </p> :
                            responseTime === 'low' ?
                            <p className='titleTimeLawyer_low'>
                                Nivel de respuesta bajo
                            </p> : ''}
                        </div>
                    </div>
                </div>
                    {!isLawyer ?
                        <div className='containerBtn'>
                            <Button
                                direction={
                                    role === 'lawyer' ? `/abogado/${uid}` :
                                    `/despacho/${uid}`
                                }
                                variant="primary"
                                style={{ width: '100%', height: 40 }}
                            >
                                Ver abogado
                            </Button>
                        </div> : null
                    }
                </div>
            </div>
            {calculateIsNotMultiple() ?
                null : <MakeYourQuestion isLawyer={isLawyer} />
            }
        </>
     );
}

const mapStateToProps = state => ({
    clientUid: state.authClient.uid,
    roleUser: state.authClient.role
})

const mapDispatchToProps = dispatch => ({
    updateLike: (
        clientUid,
        lawyerUid,
        likeStatus,
        questionId,
        answerId,
        likes,
        responseArray,
        item,
        like,
        gotLikes,
    ) =>
        dispatch(updateLike(
            clientUid,
            lawyerUid,
            likeStatus,
            questionId,
            answerId,
            likes,
            responseArray,
            item,
            like,
            gotLikes,
        ))
})
 
export default connect(mapStateToProps, mapDispatchToProps)(CardAnswerQuestion);
